var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(!_vm.collapse)?_c('div',{staticClass:"eye-logo",on:{"click":function($event){return _vm.$router.push({path: '/home'})}}}):_c('div',{staticClass:"small-eye-logo",on:{"click":function($event){return _vm.$router.push({path: '/home'})}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }